export default __webpack_public_path__ + "static/media/overview.e1a9003e.svg";